import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import { useSelector } from "react-redux";
import { Container } from "reactstrap";
import { scrollWindow } from "../../../../helpers/common";
import SmallLoader from "../../../../helpers/Common/SmallLoader";
import BookmarkJobItem from "./BookmarkJobItem";
import NoBookmarkJob from "./NoBookmarkJob";
import Section from "./Section";

// ⚠️ IMPORTANT: Import your actual API client service here.
// Adjust this path to match wherever your project keeps its backend API helpers!
import { getBookmarkJobs } from "../../../../api/bookmarkJob"; 

const ManageBookmarkJobs = () => {
  // Local states to hold data and handle loading autonomously
  const [bookmarkJobsList, setBookmarkJobsList] = useState([]);
  const [localLoading, setLocalLoading] = useState(true);

  // Grab the logged-in user profile from Redux to get their candidate ID
  const customer = useSelector((state) => state.customer.profile);

  useEffect(() => {
    scrollWindow();
    
    // Check if user is logged in and extract their candidate ID
    const candidateId = customer?.id || customer?.candidateId;

    if (candidateId) {
      console.log(`%c[BOOKMARK FETCH] Fetching bookmarks for Candidate: ${candidateId}`, "color: yellow; font-weight: bold;");
      
      // Make a direct backend server call
      getBookmarkJobs(`&candidate_id=${candidateId}`)
        .then((res) => {
          // Safely unpack response array whether it is flat or nested under .data
          const extractedData = res?.data?.data || res?.data || [];
          console.log("%c[BOOKMARK SUCCESS] Received from server:", "color: green;", extractedData);
          
          setBookmarkJobsList(extractedData);
          setLocalLoading(false); // Turn off the loader instantly on success
        })
        .catch((err) => {
          console.error("[BOOKMARK ERROR] API fetch failed:", err);
          setLocalLoading(false); // Turn off the loader even if the server fails
        });
    } else {
      console.log("%c[BOOKMARK SKIP] No logged-in candidate found.", "color: orange;");
      // If no user is logged in, give it 1 second then stop loading
      const timer = setTimeout(() => setLocalLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [customer]);

  return (
    <React.Fragment>
      <Helmet>
        <title>Bookmarked Jobs | Webvi </title>
      </Helmet>
      <Section />
      
      {/* 🛠️ Safe loading tracker built straight onto our local state tracker */}
      {localLoading ? <SmallLoader /> : null}

      <section
        className={`section ${localLoading ? "d-none" : "d-block"}`}
      >
        <Container>
          {Array.isArray(bookmarkJobsList) && bookmarkJobsList.length > 0 ? (
            bookmarkJobsList.map((item) => {
              return (
                <BookmarkJobItem
                  key={item.id || item._id}
                  bookmarkItem={item}
                />
              );
            })
          ) : (
            <NoBookmarkJob />
          )}
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ManageBookmarkJobs;